'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XOverride = exports.XDefault = exports.XTypes = undefined;

var _dec, _class, _dec2, _class2, _dec3, _class3;

exports.makeXTypes = makeXTypes;

var _node = require('./node');

let XTypes = exports.XTypes = (_dec = (0, _node.props)('xmlns'), _dec(_class = class XTypes extends _node.Node {
  constructor(_ref, children) {
    var _ref$xmlns = _ref.xmlns;
    let xmlns = _ref$xmlns === undefined ? 'http://schemas.openxmlformats.org/package/2006/content-types' : _ref$xmlns;

    super({ xmlns: xmlns }, children);
    this[_node.HEAD] = '<?xml version="1.0" encoding="UTF-8"?>';
  }
}) || _class);
let XDefault = exports.XDefault = (_dec2 = (0, _node.props)('Extension', 'ContentType'), _dec2(_class2 = class XDefault extends _node.Node {}) || _class2);
let XOverride = exports.XOverride = (_dec3 = (0, _node.props)('PartName', 'ContentType'), _dec3(_class3 = class XOverride extends _node.Node {}) || _class3);
function makeXTypes() {
  let types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new XTypes({});

  const defaults = [{
    Extension: 'rels',
    ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
  }, {
    Extension: 'xml',
    ContentType: 'application/xml'
  }];

  for (const item of defaults) {
    types.children.push(new XDefault(item));
  }

  const overrides = [{
    PartName: '/_rels/.rels',
    ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
  }, {
    PartName: '/docProps/app.xml',
    ContentType: 'application/vnd.openxmlformats-officedocument.extended-properties+xml'
  }, {
    PartName: '/docProps/core.xml',
    ContentType: 'application/vnd.openxmlformats-package.core-properties+xml'
  }, {
    PartName: '/xl/_rels/workbook.xml.rels',
    ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
  }, {
    PartName: '/xl/sharedStrings.xml',
    ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml'
  }, {
    PartName: '/xl/styles.xml',
    ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml'
  }, {
    PartName: '/xl/workbook.xml',
    ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml'
  }, {
    PartName: '/xl/theme/theme1.xml',
    ContentType: 'application/vnd.openxmlformats-officedocument.theme+xml'
  }];

  for (const override of overrides) {
    types.children.push(new XOverride(override));
  }
  return types;
}